import { useRef, useState } from 'react';

/**
 * Open state for a dropdown whose trigger also has a tooltip beside it (collapsed sidebar).
 * The two would overlap, so the tooltip never opens while the menu is open, hover intent from
 * before the menu opened is dropped, and the menu handing focus back to the trigger on close
 * does not pop the tooltip up as if the user had just tabbed there.
 */
export function useMenuTooltip() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const isRestoringFocusRef = useRef(false);

  return {
    menu: {
      open: menuOpen,
      onOpenChange: (open: boolean) => {
        setMenuOpen(open);
        if (open) {
          setTooltipOpen(false);
        }
      }
    },
    content: {
      // Radix focuses the trigger synchronously right after this handler
      onCloseAutoFocus: () => {
        isRestoringFocusRef.current = true;
        setTimeout(() => {
          isRestoringFocusRef.current = false;
        });
      }
    },
    tooltip: {
      open: tooltipOpen,
      onOpenChange: (open: boolean) => setTooltipOpen(open && !menuOpen && !isRestoringFocusRef.current)
    }
  };
}
